var render = function render(){
  var _vm$recruitment2, _vm$recruitment3, _vm$recruitment4, _vm$recruitment4$hash, _vm$recruitment5, _vm$recruitment6, _vm$recruitment7, _vm$recruitment7$empl, _vm$recruitment7$empl2, _vm$recruitment8, _vm$recruitment8$empl, _vm$recruitment9;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.recruitment,
      expression: "!recruitment"
    }],
    attrs: {
      "color": "white",
      "absolute": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "width": "5",
      "size": "100",
      "color": "primary"
    }
  })], 1)], 1), _c('recruitment-view-company', _vm._b({
    scopedSlots: _vm._u([!_vm.isPreview ? {
      key: "actions",
      fn: function () {
        var _vm$recruitment;
        return [_c('v-row', {
          staticClass: "row--small",
          attrs: {
            "justify": "end"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-btn', {
          staticClass: "like-btn",
          attrs: {
            "icon": "",
            "text": "",
            "outlined": "",
            "color": "grey-c"
          },
          on: {
            "click": _vm.copy
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey-9"
          }
        }, [_vm._v("mdi-link-variant")])], 1)], 1), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('like-btn', {
          attrs: {
            "params": {
              _recruitment: _vm._recruitment,
              type: _vm.USER_LIKE_TYPES.RECRUITMENT.value
            }
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var active = _ref.active,
                toggle = _ref.toggle;
              return [_c('v-btn', {
                staticClass: "like-btn",
                attrs: {
                  "icon": "",
                  "text": "",
                  "outlined": "",
                  "color": active ? 'yellow darken-1' : 'grey-c'
                },
                on: {
                  "click": toggle
                }
              }, [_c('v-icon', {
                attrs: {
                  "color": active ? undefined : 'grey-9'
                }
              }, [_vm._v(_vm._s(active ? "mdi-star" : "mdi-star-outline"))])], 1)];
            }
          }], null, false, 2571336929)
        })], 1), _vm.isUserWriter ? _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('recruitment-form', {
          attrs: {
            "value": _vm.recruitment
          },
          on: {
            "input": function ($event) {
              return _vm.$emit('init');
            }
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref2) {
              var attrs = _ref2.attrs,
                on = _ref2.on;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "px-lg-24",
                attrs: {
                  "color": "primary",
                  "large": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("수정하기")])];
            }
          }], null, false, 2697943171)
        })], 1) : _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('application-form-dialog', _vm._b({
          attrs: {
            "recruitmentSubject": (_vm$recruitment = _vm.recruitment) === null || _vm$recruitment === void 0 ? void 0 : _vm$recruitment.subject
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref3) {
              var attrs = _ref3.attrs,
                on = _ref3.on;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "px-lg-24",
                attrs: {
                  "color": "primary",
                  "large": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("지원하기")])];
            }
          }], null, false, 1358363486)
        }, 'application-form-dialog', {
          _recruitment: _vm._recruitment
        }, false))], 1)], 1)];
      },
      proxy: true
    } : null], null, true)
  }, 'recruitment-view-company', _vm.recruitment, false)), _c('div', {
    staticClass: "page-section"
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v(_vm._s((_vm$recruitment2 = _vm.recruitment) === null || _vm$recruitment2 === void 0 ? void 0 : _vm$recruitment2.subject))]), _c('v-divider', {
    staticClass: "border-2 primary my-16 my-lg-20"
  }), _c('recruitment-view-employment', {
    staticClass: "mb-8 mb-lg-16",
    attrs: {
      "employment": (_vm$recruitment3 = _vm.recruitment) === null || _vm$recruitment3 === void 0 ? void 0 : _vm$recruitment3.employment
    }
  }), (_vm$recruitment4 = _vm.recruitment) !== null && _vm$recruitment4 !== void 0 && (_vm$recruitment4$hash = _vm$recruitment4.hashTags) !== null && _vm$recruitment4$hash !== void 0 && _vm$recruitment4$hash.length ? _c('v-chip-group', {
    staticClass: "ma-n2"
  }, _vm._l((_vm$recruitment5 = _vm.recruitment) === null || _vm$recruitment5 === void 0 ? void 0 : _vm$recruitment5.hashTags, function (hashTag) {
    return _c('v-chip', {
      key: hashTag,
      staticClass: "grey-9--text ma-2",
      attrs: {
        "disabled": "",
        "large": "",
        "outlined": "",
        "label": "",
        "color": "grey-d"
      }
    }, [_vm._v("#" + _vm._s(hashTag))]);
  }), 1) : _vm._e(), _c('div', {
    staticClass: "mb-20 mb-lg-40 mt-16 mt-lg-20 recruitment-content",
    domProps: {
      "innerHTML": _vm._s((_vm$recruitment6 = _vm.recruitment) === null || _vm$recruitment6 === void 0 ? void 0 : _vm$recruitment6.content)
    }
  }), _c('recruitment-view-attachments', _vm._b({
    staticClass: "mb-20 mb-lg-40"
  }, 'recruitment-view-attachments', {
    recruitment: _vm.recruitment
  }, false)), _c('vertical-table', _vm._b({
    staticClass: "mb-20 mb-lg-40",
    attrs: {
      "itemsPerRow": 2
    },
    scopedSlots: _vm._u([{
      key: "접수기간",
      fn: function () {
        return [_c('recruitment-view-application', _vm._b({}, 'recruitment-view-application', {
          application: _vm.application
        }, false))];
      },
      proxy: true
    }])
  }, 'vertical-table', {
    items: _vm.items
  }, false)), (_vm$recruitment7 = _vm.recruitment) !== null && _vm$recruitment7 !== void 0 && (_vm$recruitment7$empl = _vm$recruitment7.employment) !== null && _vm$recruitment7$empl !== void 0 && (_vm$recruitment7$empl2 = _vm$recruitment7$empl.place) !== null && _vm$recruitment7$empl2 !== void 0 && _vm$recruitment7$empl2.geolocation ? _c('v-responsive', {
    staticClass: "mt-16 mt-lg-20",
    attrs: {
      "aspect-ratio": 16 / 9
    }
  }, [_c('recruitment-view-map', {
    attrs: {
      "place": (_vm$recruitment8 = _vm.recruitment) === null || _vm$recruitment8 === void 0 ? void 0 : (_vm$recruitment8$empl = _vm$recruitment8.employment) === null || _vm$recruitment8$empl === void 0 ? void 0 : _vm$recruitment8$empl.place
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "v-btn-group"
  }, [_vm.isUserWriter ? [_c('recruitment-form', {
    attrs: {
      "value": _vm.recruitment
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('init');
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref4) {
        var attrs = _ref4.attrs,
          on = _ref4.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-140px min-w-lg-160px",
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v("수정하기")])])];
      }
    }], null, false, 3171348914)
  })] : [_c('application-form-dialog', _vm._b({
    attrs: {
      "recruitmentSubject": (_vm$recruitment9 = _vm.recruitment) === null || _vm$recruitment9 === void 0 ? void 0 : _vm$recruitment9.subject
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref5) {
        var attrs = _ref5.attrs,
          on = _ref5.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-140px min-w-lg-160px",
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v("지원하기")])])];
      }
    }])
  }, 'application-form-dialog', {
    _recruitment: _vm._recruitment
  }, false))]], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }